export default __webpack_public_path__ + "static/media/qrcode-site-1024w.f12cad43.webp";